module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi2-6d7cafac9397478c4a19440d6b42af26.webp";